import React, { useContext, useEffect, useRef, useState } from "react";
import Phaser from "phaser";

import placeholderUrl from "../../../@shared/assets/GameMap/CityBG.png";
// import collisionsData from "../@shared/assets/GameMap/collisions5.json";
import {
  SPRITES_MAP,
  normalizeAvatarName,
} from "../../../@shared/utils/SpritesMap";
import {
  preloadAvatars,
  createAvatarAnimations,
} from "../../../@shared/utils/SceneHelpers";
import ArenaScene from "./ArenaScene";
import VoidCityMerchant from "./VoidCityMerchant";
import DecksmithScene from "./DecksmithScene";
import { useAuthStore } from "../../../@shared/store/useAuthStore";
import { getVoidCityNpcDialogue } from "../../../@shared/utils/npcDialogs";
import NeoButton from "../../NeoButton";
import { MainContext } from "../../../App";
import { updatePlayerPresence } from "../../../@shared/utils/roomFunctions";
import QuestHallScene from "./QuestHallScene";

import { startSceneWithTransition } from "../../../@shared/utils/startSceneWithTransition";

export const maps = {
  city: {
    background: require("../../../@shared/assets/GameMap/CityBG.png"),
    collisions: require("../../../@shared/assets/GameMap/collisions5.json"),
    size: { width: 1627, height: 1024 },
    doors: {
      ArenaDoor: { to: "arena", spawnAt: { x: 292, y: 374 } },
      MerchantsRowDoor: { to: "merchant", spawnAt: { x: 260, y: 280 } },
      DecksmithDoor: { to: "decksmith", spawnAt: { x: 145, y: 164 } },
      QestHallDoor: { to: "questHall", spawnAt: { x: 698, y: 791 } },
    },
  },
  arena: {
    background: require("../../../@shared/assets/GameMap/voidArena.png"),
    collisions: require("../../../@shared/assets/GameMap/defaultArenaInterior.json"),
    size: { width: 706, height: 471 },
    doors: {
      exit: { to: "city", spawnAt: { x: 718, y: 234 } },
    },
  },
  merchant: {
    background: require("../../../@shared/assets/GameMap/voidMerchant.png"),
    collisions: require("../../../@shared/assets/GameMap/voidMerchant.json"),
    size: { width: 595, height: 426 },
    doors: {
      exit: { to: "city", spawnAt: { x: 403, y: 190 } },
    },
  },
  decksmith: {
    background: require("../../../@shared/assets/GameMap/voidDeckSmith.png"),
    collisions: require("../../../@shared/assets/GameMap/voidDeckSmith.json"),
    size: { width: 373, height: 248 },
    doors: {
      exit: { to: "city", spawnAt: { x: 1075, y: 410 } },
    },
  },
  questHall: {
    background: require("../../../@shared/assets/GameMap/voidQuestMaster.png"),
    collisions: require("../../../@shared/assets/GameMap/voidQuestMaster.json"),
    size: { width: 706, height: 471 },
    doors: {
      exit: { to: "city", spawnAt: { x: 698, y: 791 } },
    },
  },
  // etc...
};

export default function VoidCityScene({
  setStartRoomVisible,
  setJoinRoomVisible,
  setSettingsVisible,
  setTownQuestsVisible,
  onLocalMove,
  players = {},
}) {
  const containerRef = useRef(null);
  const { userData } = useAuthStore();
  const { navigate, setMessage, setError, setScreenLoading } =
    useContext(MainContext);
  const [currentMap, setCurrentMap] = useState("city");
  const [touchingNPC, setTouchingNPC] = useState(null);
  const [npcDialogue, setNpcDialogue] = useState(null);
  const sceneRef = useRef(null); // ✅ 1. Create a ref to hold the Phaser scene

  const mapData = maps[currentMap];
  const bgImage = mapData.background;

  const { width: mapWidth, height: mapHeight } = mapData.size;

  const handleOptionKeyPress = (e) => {
    if (!npcDialogue) return;

    const keyMap = {
      1: 0,
      2: 1,
      3: 2,
    };

    const optionIndex = keyMap[e.key];
    if (optionIndex !== undefined) {
      const option = npcDialogue.options[optionIndex];
      if (!option) return;

      console.log(`🔢 Key pressed: ${e.key}, triggering: ${option}`);

      if (
        ["Okay", "Nevermind", "Exit", "Got it", "Maybe Later"].includes(option)
      ) {
        setNpcDialogue(null);
      } else {
        setSelectedOption(option);
        setNpcDialogue(null);
      }
    }
  };

  useEffect(() => {
    const handleNpcProximity = (e) => {
      const npcName = e.detail;
      console.log("🧍‍♂️ NPC in range:", npcName);
      setTouchingNPC(npcName);
    };

    const handleNpcDialogue = (e) => {
      const npcName = e.detail;

      // prevent unnecessary repeats
      if (npcDialogue || window.__npcEngaged) return;

      const dialogue = getVoidCityNpcDialogue(npcName);

      if (dialogue) {
        setNpcDialogue(dialogue);
      }
    };

    window.addEventListener("npc-proximity", handleNpcProximity);
    window.addEventListener("npc-dialogue", handleNpcDialogue);

    return () => {
      window.removeEventListener("npc-proximity", handleNpcProximity);
      window.removeEventListener("npc-dialogue", handleNpcDialogue);
    };
  }, []);

  const setSelectedOption = (option) => {
    console.log(option);
    switch (option) {
      case "Create Room":
        if (userData?.decks?.length === 0) {
          setMessage("You need to create a deck first!");
          setError(true);
          return;
        }
        setStartRoomVisible(true);
        break;
      case "Join Room":
        setJoinRoomVisible(true);
        break;
      case "Craft a Deck":
        setScreenLoading(true);
        setTimeout(() => {
          navigate("/mycards");
        }, 500);
        break;
      case "Shop":
        setScreenLoading(true);
        setTimeout(() => {
          navigate("/store");
        }, 500);
        break;
      case "Choose Quests":
        setTownQuestsVisible(true);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (!sceneRef.current) return;

    const selfId = userData.id;
    console.log("📦 SceneRef is ready:", sceneRef.current);
    // console.log("🧠 selfId:", selfId);
    // console.log("📣 Sending players to Phaser scene", players);

    sceneRef.current.events.emit("setPlayers", players, selfId);
  }, [players]);

  useEffect(() => {
    console.log("🚀 Phaser scene mounting");
    const avatarKey = normalizeAvatarName(
      userData?.avatar?.name || "io_default"
    );
    const heroUrl = SPRITES_MAP[avatarKey] || SPRITES_MAP["io_default"];
    let game;

    class VillageScene extends Phaser.Scene {
      constructor() {
        super({ key: "VillageScene" });
      }

      drawDebugBox(x, y, width, height, color = 0xff0000, alpha = 0.3) {
        const graphics = this.add.graphics();
        graphics.lineStyle(2, color, 1);
        graphics.strokeRect(x - width / 2, y - height / 2, width, height);
        graphics.fillStyle(color, alpha);
        graphics.fillRect(x - width / 2, y - height / 2, width, height);
      }

      preload() {
        this.load.image("villageBg", placeholderUrl);
        this.load.spritesheet("hero", heroUrl, {
          frameWidth: 128,
          frameHeight: 192,
        });
        preloadAvatars(this, SPRITES_MAP);
      }

      create() {
        sceneRef.current = this;
        const map = maps[currentMap];
        const bg = this.add.image(0, 0, "villageBg").setOrigin(0);
        this.cameras.main.setBounds(0, 0, bg.width, bg.height);
        this.matter.world.setBounds(0, 0, bg.width, bg.height);

        // Phaser device test:
        const isMobile =
          this.sys.game.device.os.android || this.sys.game.device.os.iOS;

        // pick zoom based on device
        const zoomLevel = isMobile ? 1.2 : 2.0;

        this.remotePlayers = {};
        this.joystick = { x: 0, y: 0 };
        const currentCollisions = map.collisions;

        // 🧱 Static Building Collisions
        currentCollisions.buildings
          .filter((b) => !b.name)
          .forEach((b) => {
            const xs = b.polygon.map((p) => p[0]);
            const ys = b.polygon.map((p) => p[1]);
            const minX = Math.min(...xs),
              maxX = Math.max(...xs);
            const minY = Math.min(...ys),
              maxY = Math.max(...ys);
            const x = minX + (maxX - minX) / 2;
            const y = minY + (maxY - minY) / 2;
            const width = maxX - minX;
            const height = maxY - minY;

            this.matter.add.rectangle(x, y, width, height, { isStatic: true });
            // this.drawDebugBox(x, y, width, height, 0xff0000, 0.15); // 🔴 RED
          });

        // 🚪 Doors with Blue Debug
        const makeDoor = (id, label) => {
          const b = currentCollisions.buildings.find((x) => x.id === id);
          if (!b) return;
          const [x0, y0] = b.polygon[0];
          const [x1, y1] = b.polygon[2];
          const x = (x0 + x1) / 2;
          const y = (y0 + y1) / 2;
          const width = x1 - x0;
          const height = y1 - y0;
          this.matter.add.rectangle(x, y, width, height, {
            isStatic: true,
            isSensor: true,
            label,
          });
          //   this.drawDebugBox(x, y, width, height, 0x0000ff, 0.3); // Blue for doors
        };
        makeDoor(42, "door_42");
        makeDoor(41, "door_41");
        makeDoor(43, "door_43");
        makeDoor(44, "door_44");

        // 🧍 NPCs with Green Debug
        currentCollisions.buildings
          .filter(
            (b) =>
              b.name &&
              [
                "receptionist",
                "merchant",
                "decksmith",
                "questmaster",
                "questboard1",
                "questboard2",
                "voidcityfrog",
              ].includes(b.name)
          )
          .forEach((b) => {
            const xs = b.polygon.map((p) => p[0]);
            const ys = b.polygon.map((p) => p[1]);
            const minX = Math.min(...xs),
              maxX = Math.max(...xs);
            const minY = Math.min(...ys),
              maxY = Math.max(...ys);
            const x = minX + (maxX - minX) / 2;
            const y = minY + (maxY - minY) / 2;
            const width = maxX - minX;
            const height = maxY - minY;

            console.log("🧍 NPC:", b.name, { x, y, width, height });

            this.matter.add.rectangle(x, y, width, height, {
              isStatic: true,
              isSensor: true,
              label: `npc_${b.name}`,
            });
            // this.drawDebugBox(x, y, width, height, 0x00ff00, 0.25); // 🟢 GREEN
          });

        this.canInteract = false;
        this.currentDoor = null;
        this.currentDoorPos = new Phaser.Math.Vector2();

        console.log("👤 Creating player sprite");
        this.player = this.matter.add
          .sprite(730, 560, "hero", 0, {
            shape: { type: "circle", radius: 32 },
          })
          .setBody({ width: 64, height: 80 }, { x: 32, y: 112 })
          .setFixedRotation();

        this.cameras.main
          .startFollow(this.player, true, 0.1, 0.1)
          .setZoom(zoomLevel);

        // Create background box
        this.playerNameBg = this.add.graphics();

        this.playerName = this.add
          .text(this.player.x, this.player.y - 100, "Loading...", {
            font: "14px Arial",
            fill: "#ffffff",
            stroke: "#000000",
            strokeThickness: 2,
          })
          .setOrigin(0.5, 1); // Center horizontally, align bottom vertically

        createAvatarAnimations(this);

        this.matter.world.on("collisionstart", (ev) => {
          ev.pairs.forEach(({ bodyA, bodyB }) => {
            const sensor = bodyA.isSensor
              ? bodyA
              : bodyB.isSensor
              ? bodyB
              : null;
            const isPlayer =
              bodyA === this.player.body || bodyB === this.player.body;

            if (sensor && isPlayer) {
              const label = sensor.label;

              if (label?.startsWith("door_")) {
                this.canInteract = true;
                this.currentDoor = label;
                this.currentDoorPos.copy(sensor.position);
                window.dispatchEvent(
                  new CustomEvent("interact-proximity", { detail: true })
                );
              } else if (label?.startsWith("npc_")) {
                const npcName = label.replace("npc_", "");
                console.log("🧍 NPC proximity detected:", npcName);
                this.canInteract = true;
                this.currentNPC = npcName;
                window.dispatchEvent(
                  new CustomEvent("npc-proximity", { detail: npcName })
                );
              }
            }
          });
        });

        this.matter.world.on("collisionend", (ev) => {
          ev.pairs.forEach(({ bodyA, bodyB }) => {
            const sensor = bodyA.isSensor
              ? bodyA
              : bodyB.isSensor
              ? bodyB
              : null;
            const isPlayer =
              bodyA === this.player.body || bodyB === this.player.body;

            if (sensor && isPlayer) {
              const label = sensor.label;

              if (label?.startsWith("door_")) {
                this.canInteract = false;
                this.currentDoor = null;
                window.dispatchEvent(
                  new CustomEvent("interact-proximity", { detail: false })
                );
              } else if (!label?.startsWith("npc_")) {
                console.log("👋 Left NPC area:", label.replace("npc_", ""));
                this.currentNPC = null;
                window.dispatchEvent(
                  new CustomEvent("npc-proximity", { detail: null })
                );
              }
            }
          });
        });

        this.lastBroadcast = {
          x: null,
          y: null,
          direction: null,
          animState: null,
        };

        ["down", "left", "right", "up"].forEach((d, i) => {
          this.anims.create({
            key: `walk-${d}`,
            frames: this.anims.generateFrameNumbers("hero", {
              start: 4 * i,
              end: 4 * i + 3,
            }),
            frameRate: 8,
            repeat: -1,
          });
        });
        this.cursors = this.input.keyboard.createCursorKeys();
        this.keys = this.input.keyboard.addKeys({
          W: Phaser.Input.Keyboard.KeyCodes.W,
          A: Phaser.Input.Keyboard.KeyCodes.A,
          S: Phaser.Input.Keyboard.KeyCodes.S,
          D: Phaser.Input.Keyboard.KeyCodes.D,
        });

        this.spaceKey = this.input.keyboard.addKey(
          Phaser.Input.Keyboard.KeyCodes.SPACE
        );
        this.spaceKey.on("down", () => {
          if (typeof this._onEnter === "function") {
            this._onEnter();
          }
        });

        this.playersFromReact = null;
        this.events.on("setPlayers", (players, selfId) => {
          console.log("🌍 Received players update from React", players);
          this.playersFromReact = { players, selfId };
          // If player sprite is already created, assign name
          if (this.player) {
            const name = players?.[selfId]?.name || "You";
            const level = players?.[selfId]?.level ?? 1;
            this.playerName?.setText(`Lv${level} ${name}`);
          }
        });

        this._onEnter = () => {
          let player = players[userData.id];
          if (this.canInteract && this.currentDoor) {
            const spawn = {
              x: this.currentDoorPos.x - 200,
              y: this.currentDoorPos.y,
            };

            if (this.currentDoor === "door_42") {
              this.scene.start("ArenaScene", spawn);

              updatePlayerPresence(userData, {
                ...player,
                building: player?.building === "arena" ? "" : "arena",
              });
            } else if (this.currentDoor === "door_41") {
              this.scene.start("MerchantScene", spawn);
              updatePlayerPresence(userData, {
                ...player,
                building: player?.building === "merchant" ? "" : "merchant",
              });
            } else if (this.currentDoor === "door_43") {
              this.scene.start("DecksmithScene", spawn);
              updatePlayerPresence(userData, {
                ...player,
                building: player?.building === "decksmith" ? "" : "decksmith",
              });
            } else if (this.currentDoor === "door_44") {
              this.scene.start("QuestHallScene", spawn);
              updatePlayerPresence(userData, {
                ...player,
                building: player?.building === "questHall" ? "" : "questHall",
              });
            }
          } else if (this.canInteract && this.currentNPC) {
            window.dispatchEvent(
              new CustomEvent("npc-dialogue", {
                detail: this.currentNPC,
              })
            );
          }
        };

        window.addEventListener("press-enter", this._onEnter);

        this.events.once("shutdown", () => {
          window.removeEventListener("press-enter", this._onEnter);
          this.spaceKey?.off?.("down"); // Clean up to avoid memory leaks

          this.currentNPC = null;
          this.currentDoor = null;
          if (typeof window !== "undefined") {
            window.__npcEngaged = false;
            window.dispatchEvent(
              new CustomEvent("npc-proximity", { detail: null })
            );
            window.dispatchEvent(
              new CustomEvent("interact-proximity", { detail: false })
            );
          }
        });
      }

      update() {
        const speed = 2;
        let vx = 0,
          vy = 0;
        const { x: jx, y: jy } = this.joystick;
        if (jx || jy) {
          vx = jx * speed;
          vy = jy * speed;
        } else {
          if (this.cursors.left.isDown || this.keys.A.isDown) {
            vx = -speed;
          } else if (this.cursors.right.isDown || this.keys.D.isDown) {
            vx = speed;
          }
          if (this.cursors.up.isDown || this.keys.W.isDown) {
            vy = -speed;
          } else if (this.cursors.down.isDown || this.keys.S.isDown) {
            vy = speed;
          }
        }

        if (vx && vy) {
          vx *= Math.SQRT1_2;
          vy *= Math.SQRT1_2;
        }

        this.player.setVelocity(vx, vy);

        if (vx < 0) this.player.anims.play("walk-left", true);
        else if (vx > 0) this.player.anims.play("walk-right", true);
        else if (vy < 0) this.player.anims.play("walk-up", true);
        else if (vy > 0) this.player.anims.play("walk-down", true);
        else {
          this.player.anims.stop();
        }

        if (this.player && this.playerName && this.playerNameBg) {
          const x = this.player.x;
          const y = this.player.y - 50;

          this.playerName.setPosition(x, y);

          const padding = 6;
          const textWidth = this.playerName.width;
          const textHeight = this.playerName.height;

          this.playerNameBg.clear();
          this.playerNameBg.fillStyle(0x000000, 0.5); // Black with 50% opacity
          this.playerNameBg.fillRoundedRect(
            x - textWidth / 2 - padding,
            y - textHeight - padding,
            textWidth + padding * 2,
            textHeight + padding * 2,
            8 // corner radius
          );
        }

        if (this.playersFromReact) {
          const { players, selfId } = this.playersFromReact;
          const currentPlayer = players[userData.id];

          if (!currentPlayer) return; // Prevent null logic

          this.playersFromReact = null;

          Object.entries(players).forEach(([uid, p]) => {
            if (
              !p ||
              uid === userData.id ||
              !p.x ||
              !p.y ||
              p.world !== currentPlayer?.world ||
              p.building !== currentPlayer?.building
            ) {
              return;
            }

            const existing = this.remotePlayers[uid];

            const avatarKey = normalizeAvatarName(p.avatar || "io_default");
            const spriteKey = `avatar-${avatarKey}`;

            if (!existing) {
              console.log("➕ Adding remote player sprite", uid);
              const sprite = this.add
                .sprite(p.x, p.y, spriteKey, 0)
                .setAlpha(0.8)
                .setDisplaySize(
                  this.player.displayWidth,
                  this.player.displayHeight
                );

              const nameTagBg = this.add.graphics();
              const level = p.level ?? 1;
              const nameTag = this.add
                .text(p.x, p.y - 50, `Lv${level} ${p.name || "Unknown"}`, {
                  font: "14px Arial",
                  fill: "#ffffff",
                  stroke: "#000000",
                  strokeThickness: 3,
                })
                .setOrigin(0.5, 1);

              const padding = 6;
              const textWidth = nameTag.width;
              const textHeight = nameTag.height;
              nameTagBg.fillStyle(0x000000, 0.5);
              nameTagBg.fillRoundedRect(
                p.x - textWidth / 2 - padding,
                p.y - 50 - textHeight - padding,
                textWidth + padding * 2,
                textHeight + padding * 2,
                8
              );

              this.remotePlayers[uid] = { sprite, nameTag, nameTagBg };
            } else {
              const level = p.level ?? 1;
              existing.sprite.setPosition(p.x, p.y);
              existing.nameTag.setPosition(p.x, p.y - 50);
              existing.nameTag.setText(`Lv${level} ${p.name || "Unknown"}`);

              const padding = 6;
              const textWidth = existing.nameTag.width;
              const textHeight = existing.nameTag.height;

              existing.nameTagBg.clear();
              existing.nameTagBg.fillStyle(0x000000, 0.5);
              existing.nameTagBg.fillRoundedRect(
                p.x - textWidth / 2 - padding,
                p.y - 50 - textHeight - padding,
                textWidth + padding * 2,
                textHeight + padding * 2,
                8
              );
            }

            const dirMap = { 0: 0, 270: 1, 90: 2, 180: 3 };
            const row = dirMap[p.direction] ?? 0;
            const frameOffset =
              p.animState === "walking" ? ((Date.now() % 400) / 100) | 0 : 0;
            this.remotePlayers[uid].sprite.setFrame(row * 4 + frameOffset);
          });

          // Clean up removed players
          Object.keys(this.remotePlayers).forEach((uid) => {
            const p = players[uid];
            if (
              !p ||
              uid === selfId ||
              p.world !== currentPlayer.world ||
              p.building !== currentPlayer.building
            ) {
              console.log("❌ Removing remote player sprite", uid);
              this.remotePlayers[uid].sprite.destroy();
              this.remotePlayers[uid].nameTag.destroy();
              this.remotePlayers[uid].nameTagBg.destroy?.();
              delete this.remotePlayers[uid];
            }
          });
        }

        if (onLocalMove) {
          const dir =
            vx < 0
              ? 270 // left
              : vx > 0
              ? 90 // right
              : vy < 0
              ? 180 // up
              : vy > 0
              ? 0 // down
              : null;

          const animState = vx === 0 && vy === 0 ? "idle" : "walking";

          const shouldBroadcast =
            this.player.x !== this.lastBroadcast.x ||
            this.player.y !== this.lastBroadcast.y ||
            dir !== this.lastBroadcast.direction ||
            animState !== this.lastBroadcast.animState;

          if (shouldBroadcast) {
            this.lastBroadcast = {
              x: this.player.x,
              y: this.player.y,
              direction: dir,
              animState,
            };
            onLocalMove(this.player.x, this.player.y, dir ?? 0, animState);
          }
        }
      }
    }

    game = new Phaser.Game({
      type: Phaser.AUTO,
      parent: containerRef.current,
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: "100%",
        height: "100%",
      },
      pixelArt: true,
      physics: {
        default: "matter",
        matter: {
          debug: false, //RESPONSIBLE FOR BORDER
          gravity: { y: 0 },
          debugShowBody: true,
          debugShowStaticBody: true,
        },
      },
      scene: [
        VillageScene,
        ArenaScene,
        VoidCityMerchant,
        DecksmithScene,
        QuestHallScene,
      ],
    });

    // const handleMove = (e) => {
    //   const { dx, dy } = e.detail;
    //   game.scene.keys.VillageScene.joystick = { x: dx, y: dy };
    // };

    const handleMove = (e) => {
      const { dx, dy } = e.detail;
      [
        "VillageScene",
        "MerchantScene",
        "DecksmithScene",
        "QuestHallScene",
        "ArenaScene",
      ].forEach((key) => {
        if (game.scene.keys[key]) {
          game.scene.keys[key].joystick = { x: dx, y: dy };
        }
      });
    };

    const handleRelease = () => {
      [
        "VillageScene",
        "MerchantScene",
        "DecksmithScene",
        "QuestHallScene",
        "ArenaScene",
      ].forEach((k) => {
        if (game.scene.keys[k]) {
          game.scene.keys[k].joystick = { x: 0, y: 0 };
        }
      });
    };

    // const handleRelease = () => {
    //   game.scene.keys.VillageScene.joystick = { x: 0, y: 0 };
    // };

    window.addEventListener("joystick-move", handleMove);
    window.addEventListener("joystick-release", handleRelease);

    return () => {
      game.destroy(true);
      window.removeEventListener("joystick-move", handleMove);
      window.removeEventListener("joystick-release", handleRelease);
    };
  }, [onLocalMove]);

  useEffect(() => {
    if (npcDialogue) {
      window.addEventListener("keydown", handleOptionKeyPress);
    } else {
      window.removeEventListener("keydown", handleOptionKeyPress);
    }

    return () => {
      window.removeEventListener("keydown", handleOptionKeyPress);
    };
  }, [npcDialogue]);

  useEffect(() => {
    setNpcDialogue(null); // Defensive reset when scene re-inits
  }, []);

  return (
    <>
      <div ref={containerRef} style={{ width: "100%", height: "100%" }} />;
      {npcDialogue && (
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            right: "5%",
            backgroundColor: "rgba(0,0,0,0.8)",
            padding: "16px",
            borderRadius: "12px",
            zIndex: 1000,
            width: "160px",
            color: "#fff",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {npcDialogue.options.map((option, idx) => (
              <NeoButton
                key={idx}
                color={option === "Nevermind" ? "#ef4444" : "#3b82f6"}
                width={100}
                text={option}
                onClick={() => {
                  console.log(`🟢 Selected: ${option}`);
                  if (
                    ["Okay", "Nevermind", "Exit", "Got it", "Maybe Later"].find(
                      (word) => word === option
                    )
                  ) {
                    setNpcDialogue(null);
                  } else {
                    setSelectedOption(option);
                    setNpcDialogue(null);
                  }
                }}
              >
                {option}
              </NeoButton>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
